export enum LookupFields {
  ManufacturerID = 'ManufacturerID',
  TypeID = 'TypeID'
}
